import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import "src/app/core/rxjs/extensions";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { ReciteMe } from './embeds/reciteme';

if (!environment.debug) {
  enableProdMode();
}

if (ReciteMe.configured()) {
  ReciteMe.enable();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
